import { Application } from "@hotwired/stimulus"
import AccordionController from "./accordion_controller"
import MapController from "./map_controller"  // 👈 Ajout important !

const application = Application.start()
application.debug = false
window.Stimulus = application

application.register("accordion", AccordionController)
application.register("map", MapController)    // 👈 On enregistre le contrôleur "map"
